import React, { FC } from 'react';
import { TaskStatusChanged } from 'api/notifications/meta';
import { TaskType } from 'api/tasks';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { useTranslation } from 'hooks/use-translation';
import { FieldChangedMessage } from './field-changed';
import { getStatusValue } from './task/utils';

export const TaskStatusChangedView: FC<{
  meta: TaskStatusChanged;
  type: TaskType;
}> = ({ meta: { by, from, to, externalUser }, type }) => {
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  return (
    <FieldChangedMessage
      name={useTranslation('fields.status')}
      by={userDetails}
      from={from != null ? getStatusValue(type, from) : null}
      to={to != null ? getStatusValue(type, to) : null}
    />
  );
};
